<prlw-table-ui
  [data]="data$ | async"
  [columns]="columns$ | async"
  [valuesChanges]="valuesChanges$ | async"
  [hasUnselectedBases]="hasUnselectedBases$ | async"
  [noBasesAvailable]="noBasesAvailable$ | async"
  [noSubProductsSelected]="noSubProductsSelected$ | async"
  [gridSize]="gridSize$ | async"
  [overflows]="overflows$ | async"
  [preloaderActive]="preloaderActive$ | async"
  [reqInstrumentsResult]="reqInstrumentsResult$ | async"
  [isExpanded]="isExpanded$ | async"
  (openManageOverlay)="openManageOverlay()"
  (openBasisOverlay)="openBasisOverlay()"
  (removeBasisOutput)="removeBasis($event)"
  (removeProductByName)="unselectProduct($event)"
  (initResizeObserver)="initResizeObserver($event)"
  (setScrollHorizontalPosition)="setScrollHorizontalPosition($event)"
  (setScrollVerticalPosition)="setScrollVerticalPosition($event)"
  (eventToggleActiveMobile)="handleToggleActiveMobile($event)"
  (eventOnLoaded)="pagePreloaderService.emit()"
></prlw-table-ui>
